<template>
  <button
    class="v-button"
    :class="{
      hover,
      loading,
      disabled,
      outlined
    }"
    :type="type"
    @click.prevent="handleClick"
  >
    <div
      v-if="showBackgroundAnimation"
      class="background-animation"
    >
      <div class="line" />
    </div>

    <slot name="loading">
      <IconLoading v-if="animated && loading" />
    </slot>

    <span><slot /></span>

    <slot name="custom-label" />
  </button>
</template>

<script>
import IconLoading from '../../IconLoading'

export default {
  name: 'VButton',
  components: {
    IconLoading
  },
  props: {
    type: {
      type: String,
      default: 'button'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hover: {
      type: Boolean,
      default: false
    },
    // 是否显示 loading 动画
    animated: {
      type: Boolean,
      default: true
    },
    showBackgroundAnimation: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(e) {
      if (this.loading) {
        this.$emit('on-loading', e)
        return
      }
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="less">
@line-offset-x: 5px;

@keyframes translate-right {
  0% {
    transform: skew(-15deg) translate(calc(-5px - @line-offset-x));
  }

  37.5% {
    transform: skew(-15deg) translate(calc(80px + @line-offset-x));
  }

  100% {
    transform: skew(-15deg) translate(calc(80px + @line-offset-x));
  }
}

.v-button {
  position: relative;
  display: flex;
  width: 100%;
  height: 44px;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  border: none;
  border-radius: 22px;
  appearance: none;
  background: #ffca27;
  color: #000;
  cursor: pointer;
  font-size: 16px;
  line-height: 44px;
  outline: none;
  text-align: center;
  transition: all 0.3s;

  &.outlined {
    border: 1px solid #ffca27;
    background: white;
  }

  &.hover {
    &:hover {
      background: #ffefbf;
    }

    &:active {
      background: #b28d1b;
    }
  }

  &:active {
    background: #b28d1b;
  }

  &.disabled,
  &.loading {
    cursor: not-allowed;
  }

  &.disabled {
    background: #ffefbf;
    color: #999;
  }

  &.loading {
    background: #ffefbf;
    color: #666;
  }

  .icon-loading {
    margin-right: 10px;
  }

  .background-animation {
    position: absolute;
    overflow: hidden;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    isolation: isolate; // fix: safari(16.3) overflow content exceeds border-radius

    .line {
      width: 0;
      height: 100%;
      animation: translate-right linear 2s infinite;
      background-color: white;
      box-shadow: 0 0 3px 2px rgba(255, 255, 255, 85%);
    }
  }
}
</style>
